import Vue from 'vue'
import VueUnits from 'vue-units'

Vue.use(VueUnits)
